/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import faker from 'faker';
import { Factory, association } from 'miragejs';

const twilioConfiguration = Factory.extend({
  account: association(),
  cached_subaccount_status: () => 'active',
  subaccount_account_sid: () => faker.datatype.uuid(),
  subaccount_auth_token: () => faker.datatype.uuid(),
  messaging_service_sid: () => faker.datatype.uuid(),
});

export default twilioConfiguration;
